import React, { PropsWithChildren } from 'react'

import { BasicModal } from '../BasicModal'
import { InfoModalProps } from './InfoModal'

export const InfoModalDesktop: React.FC<PropsWithChildren<InfoModalProps>> = (props) => {
  const { size, title, children } = props
  const { onClose } = props

  return (
    <BasicModal title={title} size={size} onClose={onClose} hasCloseButton>
      {children}
    </BasicModal>
  )
}
